import React from 'react';
import {
  Button,
  Link,
  NumberInput,
  ScreenContainer,
  SimpleStyleKeyboardAwareScrollView,
  withTheme,
} from '@draftbit/ui';
import { Image, Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as AuthenticationApi from '../apis/AuthenticationApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import checkExpires from '../global-functions/checkExpires';
import checkScreenMode from '../global-functions/checkScreenMode';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = {
  expires_at: null,
  screen_from: null,
  subscription_plans_id: null,
};

const AccountVerificationScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [otp, setOtp] = React.useState('');
  const inputValid = () => {
    const expr =
      /^([\w-\.]+)@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/;
    const passwordExpr = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;

    let foundError = false;

    if (firstName.length < 1) {
      setErrorMessage('Please enter first name');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (lastName.length < 1) {
      setErrorMessage('Please enter last name');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (phone.length < 1) {
      setErrorMessage('Please enter a phone number');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (email.length < 1) {
      setErrorMessage('Please enter your email');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (!expr.test(email)) {
      setErrorMessage('Please enter a valid email');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (password.length < 1) {
      setErrorMessage('Please enter a password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (!password.match(passwordExpr)) {
      setErrorMessage(
        'Password must be 8+ characters and at least 1 uppercase, 1 lowercase, 1 digit.'
      );
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (confirmPassword.length < 1) {
      setErrorMessage('Please re-enter the password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (confirmPassword != password) {
      setErrorMessage('Passwords do not match');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    return foundError;
  };

  const resetInputs = () => {
    setFirstName('');
    setLastName('');
    setPhone('');
    setEmail('');
    setPassword('');
    setConfirmPassword('');
    setErrorMessage('');
  };
  const authenticationVerifyOTPForEmailPOST =
    AuthenticationApi.useVerifyOTPForEmailPOST();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
        },
        dimensions.width
      )}
    >
      <SimpleStyleKeyboardAwareScrollView
        enableAutomaticScroll={false}
        enableOnAndroid={false}
        enableResetScrollToCoords={false}
        keyboardShouldPersistTaps={'never'}
        showsVerticalScrollIndicator={true}
        viewIsInsideTabBar={false}
        style={StyleSheet.applyWidth(
          { alignItems: 'center', flex: 1, margin: 20 },
          dimensions.width
        )}
      >
        {/* Logo */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
              justifyContent: { minWidth: Breakpoints.Laptop, value: 'center' },
              margin: 20,
              paddingBottom: { minWidth: Breakpoints.Laptop, value: 50 },
              paddingTop: { minWidth: Breakpoints.Laptop, value: 50 },
            },
            dimensions.width
          )}
        >
          {/* Image 2 */}
          <Image
            {...GlobalStyles.ImageStyles(theme)['Image'].props}
            resizeMode={'contain'}
            source={imageSource(Images['logocropped'])}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.ImageStyles(theme)['Image'].style,
                {
                  height: [
                    { minWidth: Breakpoints.Desktop, value: 150 },
                    { minWidth: Breakpoints.Laptop, value: 200 },
                    { minWidth: Breakpoints.Mobile, value: 200 },
                  ],
                  width: [
                    { minWidth: Breakpoints.Desktop, value: 150 },
                    { minWidth: Breakpoints.Laptop, value: 200 },
                    { minWidth: Breakpoints.Mobile, value: 200 },
                  ],
                }
              ),
              dimensions.width
            )}
          />
        </View>
        {/* Inputs */}
        <View
          style={StyleSheet.applyWidth(
            {
              gap: [
                { minWidth: Breakpoints.Desktop, value: 30 },
                { minWidth: Breakpoints.Laptop, value: 30 },
                { minWidth: Breakpoints.Mobile, value: 20 },
              ],
              margin: 20,
              marginTop: [
                { minWidth: Breakpoints.Laptop, value: 20 },
                { minWidth: Breakpoints.Mobile, value: 50 },
              ],
              width: [
                { minWidth: Breakpoints.Desktop, value: '20%' },
                { minWidth: Breakpoints.Laptop, value: '25%' },
                { minWidth: Breakpoints.Tablet, value: '30%' },
              ],
            },
            dimensions.width
          )}
        >
          <Text
            accessible={true}
            selectable={false}
            {...GlobalStyles.TextStyles(theme)['Text'].props}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(GlobalStyles.TextStyles(theme)['Text'].style, {
                color: palettes.Brand.White,
                fontFamily: 'OpenSans_500Medium',
                textAlign: 'center',
              }),
              dimensions.width
            )}
          >
            {
              'Your email has not been verified. Please check your email for a code to verify your account.'
            }
          </Text>
          {/* OTP */}
          <NumberInput
            changeTextDelay={500}
            onChangeText={newOTPValue => {
              try {
                setOtp(newOTPValue);
              } catch (err) {
                console.error(err);
              }
            }}
            webShowOutline={true}
            {...GlobalStyles.NumberInputStyles(theme)['Number Input'].props}
            placeholder={'Enter OTP'}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.NumberInputStyles(theme)['Number Input'].style,
                {
                  backgroundColor: [
                    {
                      minWidth: Breakpoints.Laptop,
                      value: palettes.Brand.White,
                    },
                    {
                      minWidth: Breakpoints.Mobile,
                      value: palettes.Brand.White,
                    },
                  ],
                  fontFamily: [
                    {
                      minWidth: Breakpoints.Laptop,
                      value: 'OpenSans_500Medium',
                    },
                    {
                      minWidth: Breakpoints.Mobile,
                      value: 'OpenSans_500Medium',
                    },
                  ],
                  fontSize: [
                    { minWidth: Breakpoints.Laptop, value: 16 },
                    { minWidth: Breakpoints.Mobile, value: 16 },
                  ],
                }
              ),
              dimensions.width
            )}
            value={otp}
          />
        </View>
        {/* Buttons */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
              marginTop: [
                { minWidth: Breakpoints.Laptop, value: '10%' },
                { minWidth: Breakpoints.Mobile, value: 50 },
              ],
              width: { minWidth: Breakpoints.Laptop, value: '100%' },
            },
            dimensions.width
          )}
        >
          {/* Error Message */}
          <>
            {!errorMessage ? null : (
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand['App Red'],
                      },
                      fontFamily: {
                        minWidth: Breakpoints.Laptop,
                        value: 'OpenSans_400Regular',
                      },
                      fontSize: { minWidth: Breakpoints.Laptop, value: 14 },
                      marginBottom: { minWidth: Breakpoints.Laptop, value: 10 },
                      paddingBottom: [
                        { minWidth: Breakpoints.Desktop, value: 4 },
                        { minWidth: Breakpoints.Laptop, value: 4 },
                      ],
                      paddingTop: { minWidth: Breakpoints.Laptop, value: 4 },
                      textAlign: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                    }
                  ),
                  dimensions.width
                )}
              >
                {errorMessage}
              </Text>
            )}
          </>
          {/* Submit */}
          <Button
            accessible={true}
            iconPosition={'left'}
            onPress={() => {
              const handler = async () => {
                try {
                  if (otp) {
                    setErrorMessage('');
                    setIsLoading(true);
                    const verifyRes = (
                      await authenticationVerifyOTPForEmailPOST.mutateAsync({
                        otp: otp,
                      })
                    )?.json;
                    if (verifyRes?.status) {
                      setOtp('');
                      if (
                        (props.route?.params?.screen_from ??
                          defaultProps.screen_from) === 'login'
                      ) {
                        if (
                          props.route?.params?.subscription_plans_id ??
                          defaultProps.subscription_plans_id
                        ) {
                          if (
                            checkExpires(
                              props.route?.params?.expires_at ??
                                defaultProps.expires_at
                            )
                          ) {
                            navigation.navigate('PaymentPlanSelectionScreen', {
                              screen_from: 'verify',
                            });
                          } else {
                            navigation.navigate('DashboardScreen');
                          }
                        } else {
                          navigation.navigate('PaymentPlanSelectionScreen', {
                            screen_from: 'verify',
                          });
                        }
                      } else {
                        navigation.navigate('PaymentPlanSelectionScreen', {
                          screen_from: 'verify',
                        });
                      }
                    } else {
                      setErrorMessage(
                        'Something went wrong! Please try again!'
                      );
                    }
                  } else {
                    setErrorMessage('Enter OTP code');
                  }

                  setIsLoading(false);
                } catch (err) {
                  console.error(err);
                }
              };
              handler();
            }}
            {...GlobalStyles.ButtonStyles(theme)['New Submit Button'].props}
            loading={isLoading}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.ButtonStyles(theme)['New Submit Button'].style,
                { backgroundColor: palettes.Brand['App Green'] }
              ),
              dimensions.width
            )}
            title={'Verify'}
          />
          <Link
            accessible={true}
            onPress={() => {
              try {
                navigation.navigate('LoginScreen');
              } catch (err) {
                console.error(err);
              }
            }}
            selectable={false}
            {...GlobalStyles.LinkStyles(theme)['Link'].props}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(GlobalStyles.LinkStyles(theme)['Link'].style, {
                color: [
                  {
                    minWidth: Breakpoints.Desktop,
                    value: palettes.Brand['App Green'],
                  },
                  {
                    minWidth: Breakpoints.Laptop,
                    value: palettes.Brand['App Green'],
                  },
                  {
                    minWidth: Breakpoints.Mobile,
                    value: palettes.Brand['App Green'],
                  },
                ],
                fontFamily: [
                  { minWidth: Breakpoints.Desktop, value: 'Inter_600SemiBold' },
                  { minWidth: Breakpoints.Laptop, value: 'Inter_600SemiBold' },
                  {
                    minWidth: Breakpoints.Mobile,
                    value: 'OpenSans_600SemiBold',
                  },
                ],
                fontSize: [
                  { minWidth: Breakpoints.Desktop, value: 18 },
                  { minWidth: Breakpoints.Laptop, value: 18 },
                  { minWidth: Breakpoints.Mobile, value: 18 },
                ],
                marginTop: [
                  { minWidth: Breakpoints.Laptop, value: 40 },
                  { minWidth: Breakpoints.Mobile, value: 20 },
                  { minWidth: Breakpoints.Tablet, value: 40 },
                ],
                textTransform: [
                  { minWidth: Breakpoints.Desktop, value: 'uppercase' },
                  { minWidth: Breakpoints.Laptop, value: 'uppercase' },
                  { minWidth: Breakpoints.Mobile, value: 'uppercase' },
                ],
              }),
              dimensions.width
            )}
            title={'Back to Login'}
          />
        </View>
      </SimpleStyleKeyboardAwareScrollView>
    </ScreenContainer>
  );
};

export default withTheme(AccountVerificationScreen);
